import { useMemo } from "react";
import {
  Breadcrumb,
  DownloadExcel,
  EnvelopeIcon,
  ErrorAlert,
  Modal,
  modalHandler,
  ModalOpenBtn,
  PageHero,
  SearchToggle,
  TableRowsPerPage,
  useFetchData,
  useSearch,
  useState,
} from "@";
import { DataTable } from "@/shared/components/tanstackTable";
import Show from "./components/Show";
import { getContactMessages } from "./utils/api";
import MultiSearch from "./components/MultiSearch";
import { excelHeaderCellsName, searchValues } from "./utils/options";
import { TableActions, tableColumns } from "./components/TableOptions";

const Index = () => {
  const links = [{ name: "التواصل", link: "" }];
  const [messageData, setMessageData] = useState({});
  const { search, updateSearch } = useSearch(searchValues);

  const { data, isLoading, setData, error, pg, fetchData, updatePg } =
    useFetchData({
      fun: getContactMessages,
      params: [search.values],
    });

  // Append actions column
  const columns = useMemo(
    () => [
      ...tableColumns,
      {
        id: "actions",
        header: "خيارات",
        size: 100,
        cell: ({ row }) => (
          <TableActions
            row={row.original}
            show={(item) => {
              setMessageData(item);
              modalHandler();
            }}
          />
        ),
      },
    ],
    [],
  );

  return (
    <>
      <ErrorAlert reload={fetchData} show={error} />
      <Breadcrumb links={links} />

      <ModalOpenBtn hidden />
      <Modal size="max-w-7xl" close={() => {}} title="تفاصيل رسالة">
        <Show fetchData={fetchData} setData={setData} values={messageData} />
      </Modal>

      <main className="table-card relative">
        <PageHero
          eyebrow="العمليات / التواصل"
          title="المراسلات السابقة"
          count={data?.length}
          icon={EnvelopeIcon}
          hideCount={isLoading}
          headerClassName="flex-row items-center justify-between"
        >
          <TableRowsPerPage
            pagination={pg}
            onRowsPerPageChange={(size) => updatePg({ size })}
          />

          <DownloadExcel
            headerCellsName={excelHeaderCellsName}
            pageSize=""
            length={data?.length}
            search={search.values}
            fetch={getContactMessages}
          />

          <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
        </PageHero>

        <MultiSearch
          search={search}
          onSubmit={fetchData}
          updateSearch={updateSearch}
        />

        <DataTable
          data={data}
          columns={columns}
          isLoading={isLoading}
          pagination={pg}
          onPageChange={(page) => updatePg({ page })}
          onPageSizeChange={(size) => updatePg({ size, page: 1 })}
        />
      </main>
    </>
  );
};

export default Index;
